import { Component, input, Input } from '@angular/core';
import {computeColorFromString} from '@irian-ro/shared-components-module';
import { translationSchema } from '@well/translation';

@Component({
  selector: 'well-person-circle',
  templateUrl: './person-circle.component.html',
  styleUrls: ['./person-circle.component.scss'],
})
export class PersonCircleComponent {

  private _name: string | undefined = undefined;

  private _companyName: string | undefined = undefined;

  @Input() set name(value: string) {
    this._name = value;
    this.personAcronym = this.computeInitialsFromString(this._name);
    this.color = computeColorFromString(this._name);
  }

  get name(): string | undefined {
    return this._name;
  }

  @Input() set companyName(value: string){
    this._companyName = value;
  }

  get companyName(): string | undefined {
    return this._companyName;
  }

  personAcronym: string | undefined = undefined;
  color: string | undefined = undefined;

  inactive = input.required<boolean>();

  private computeInitialsFromString(str: string): string {
    const initialMatch = str.match(/\b(\w)/g);
    if(!initialMatch) {
      return '';
    }
    return initialMatch.join('');
  }

  protected readonly translationSchema = translationSchema;
}
